<template>
  <footer v-responsive="_updateHeight" class="app-footer" :style="styles">
    <div ref="content" class="app-footer__wrap">
      <slot></slot>
    </div>
  </footer>
</template>

<script>
import Applicationable from "@mixins/applicationable";
import { convertToUnit } from "@utils/helpers";
import mixins from "@utils/mixins";

export default mixins(Applicationable("footer", ["computedHeight"])).extend({
  name: "AppFooterDrawer",

  data() {
    return {
      internalContentHeight: 0
    };
  },

  computed: {
    computedHeight() {
      return this.internalContentHeight;
    },

    computedLeft() {
      return this.$core.application.left;
    },

    computedRight() {
      return this.$core.application.right;
    },

    computedBottom() {
      return this.$core.application.bottom;
    },

    styles() {
      return {
        bottom: convertToUnit(this.computedBottom),
        left: convertToUnit(this.computedLeft),
        right: convertToUnit(this.computedRight)
      };
    }
  },

  methods: {
    updateApplication() {
      return this.computedHeight;
    },

    _updateHeight() {
      this.internalContentHeight =
        (this.$refs.content && this.$refs.content.clientHeight) || 0;
    }
  }
});
</script>

<style lang="scss">
.app-footer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: auto;
  z-index: 8;
}
</style>
